/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import { DashboardSelection } from './dashboard-selection';
import { setActiveDashboard, setActiveDashboardResource } from '../../actions/analytics';
const mapStateToProps = (state)=>{
    const { analytics, ui } = state;
    return {
        activeDashboard: analytics.activeDashboard,
        resources: ui.context.activeContext?.resources ?? [],
        dashboardPaths: analytics.dashboardPaths,
        activeContext: ui.context.activeContext
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleDashboardSelection: (boardName, dashboardResource)=>{
            runDispatchable(()=>{
                dispatch(setActiveDashboard(boardName.split(' ')[0].toLowerCase()));
                dispatch(setActiveDashboardResource(dashboardResource));
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardSelection);
